/**
 * Convert a simple pattern like "GET /api/users/:id" to a regex
 */
export function patternToRegex(pattern: string): RegExp {
  const [, path] = pattern.split(' ');

  // Escape special regex characters except :
  const escapedPath = path
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    // Replace :param with regex capture group
    .replace(/:(\w+)/g, '([^/]+)');

  return new RegExp(`^${escapedPath}$`);
}

/**
 * Extract method and path from a pattern
 */
export function parsePattern(pattern: string): { method: string; path: string } {
  const [method, path] = pattern.split(' ');
  return { method: method.toUpperCase(), path };
}

/**
 * Match a URL against a pattern
 */
export function matchPattern(pattern: string, method: string, url: string): boolean {
  const { method: patternMethod } = parsePattern(pattern);

  if (patternMethod !== method.toUpperCase()) {
    return false;
  }

  const regex = patternToRegex(pattern);
  return regex.test(url);
}

/**
 * Extract the API path from a full URL
 */
export function extractApiPath(url: string): string {
  // Handle proxy URLs - extract the actual API path
  if (url.includes('/api/v1/')) {
    // URL already has the full path
    return url.substring(url.indexOf('/api/v1/'));
  }

  // URL is missing /api/v1/ prefix, add it
  if (!url.startsWith('/api/')) {
    return `/api/v1/${url}`;
  }

  return url;
}
